<script setup>
import { icons, meta, sortCats } from "lib/modules/cat";
import { sortByKey } from "lib/modules/util";
import { catNames } from "db";
import Card from "lib/srv/components/Card";
import { addSrvsSchema } from "lib/modules/schema";

const props = defineProps(["srvs", "pcatId", "ccy"]);

const pcat = meta[props.pcatId];

let cats = {};

for (const srv of props.srvs) {
	if (!(srv.cat_id in cats))
		cats[srv.cat_id] = null;
}

cats = Object.keys(cats).map((cat_id) => {
	return { cat_id, name: catNames[`${props.pcatId}/${cat_id}`] };
});

sortCats(cats, "cat_id");
sortByKey(props.srvs, "^publish");
addSrvsSchema(props.srvs, props.ccy);
</script>

<template>
	<div class="page-marketplace">
		<template v-if="pcat">
			<h1>{{ $gettext("Find your %1", pcat.position) }}</h1>
			<div class="intro">{{ pcat.intro }}</div>
		</template>
		<h1 v-else>{{ catNames[pcatId] || $gettext("No such category") }}</h1>
		<div v-if="cats.length === 0" class="no-services">{{ $gettext("No services found") }}</div>
		<template v-else>
			<UiScrollX class="index">
				<a v-for="cat in cats" :href="`category/${pcatId}/${cat.cat_id}`">
					<i class="fa-light" :class="icons[`${pcatId}/${cat.cat_id}`] || 'fa-user-hair'"></i>
					<span>{{ cat.name }}</span>
				</a>
				<a class="add" href="add">
					<i class="fa-light fa-sparkles"></i>
					<span>{{ $gettext("Add your service") }}</span>
				</a>
			</UiScrollX>
			<div class="path">
				<a href="">Vixly</a>
				<i class="fa-regular fa-chevron-right"></i>
				<span>{{ catNames[pcatId] }}</span>
			</div>
		</template>
		<div class="services grid">
			<Card v-for="srv in srvs" :key="srv.srv_id" :cat-name="catNames[`${pcatId}/${srv.cat_id}`]" :ccy="ccy" :srv="srv"/>
		</div>
		<div v-if="pcat" class="steps grid">
			<div class="step">
				<i class="fa-solid fa-circle-1"></i>
				<h2>{{ $gettext("Find") }}</h2>
				<div>{{ pcat.find }}</div>
			</div>
			<div class="step">
				<i class="fa-solid fa-circle-2"></i>
				<h2>{{ $gettext("Book") }}</h2>
				<div>{{ pcat.book }}</div>
			</div>
			<div class="step">
				<i class="fa-solid fa-circle-3"></i>
				<h2>{{ $gettext("Meet") }}</h2>
				<div>{{ pcat.meet }}</div>
			</div>
		</div>
	</div>
</template>
